import React, { useCallback, useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import { Grid } from "src/shared/grid";
import { useStoreContext } from 'src/store/context';
import { useAddAlert } from 'src/store/actions';
import { getStationMeta } from 'src/apis/getWeatherCalls';
import { checkAdminRole, slopeConversion } from 'src/store/common';
import { Button, IconButton, Modal } from "@mui/material";
import { AddStation } from "src/features/station-management/modal/AddStation";
import { modalStyle } from "src/shared/Styles/Styles";
import CloseIcon from '@mui/icons-material/Close';


type StationMetaProps = {
  station: any
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

export const StationMetaDataTab: React.FC<StationMetaProps> = ({ station }) => {
  const [, dispatch] = useStoreContext();
  const addAlert = useAddAlert(dispatch);
  const [stationMeta, setStationMeta] = useState<any>(null);
  const [state] = useStoreContext();
  const [ openStationModal, setOpenStationModal ] = useState<boolean>(false)
  const [ createUpdateStationSuccess, setCreateUpdateStationSuccess ] = useState<boolean>(false)
  const [stationFailCount, setStationFailCount ] = useState<number>(0);
  const getMeta = useCallback((station: any, counter:number) => {
    (async () => {
      const { station_id } = station;
      try {
        const varRequest = {
          stationId: station_id.toString()
        };
        const response: any = await getStationMeta(varRequest, addAlert, state?.user);
        if (response) {
          setStationMeta(response);
          setCreateUpdateStationSuccess(false);
          setStationFailCount(0);

        }
        else{
          setStationMeta(null)
          setCreateUpdateStationSuccess(false);
          setStationFailCount(counter+1);
        }
      }
      catch (error) {
        console.log('error', error)
        setCreateUpdateStationSuccess(false);
        setStationMeta(null)
        setStationFailCount(counter+1);
      }
    })();
  }, [addAlert, setStationMeta, state?.user, setStationFailCount]);

  useEffect(()=>{
    if (station?.station_id) {
      getMeta(station, stationFailCount);
    }
  },[station, getMeta, stationFailCount])


  useEffect(() => {
    if(createUpdateStationSuccess){
      getMeta(station, stationFailCount);
    }
    if(station?.station_id && stationFailCount>0 && stationFailCount<4){
      getMeta(station, stationFailCount);
    }
  }, [station, getMeta, createUpdateStationSuccess, stationFailCount]);


  return (
    <Box sx={{ width: '99%', paddingTop: '1rem' }}>
      <Stack spacing={2}>
            {state.user && checkAdminRole(state.user) &&
              <Modal //Modal to open edit/create dead
                className="smooth-scrollbar"
                open={openStationModal}
                onClose={()=>setOpenStationModal(false)}
              >
                <div>
                  <IconButton aria-label='close' style={{ left: '73.5%', top: '5.5%', position: 'absolute', cursor: 'pointer' }} onClick={() => { setOpenStationModal(false) }}>
                    <CloseIcon style={{ color: 'white' }} />
                  </IconButton>
                  <Box sx={modalStyle} className="smooth-scrollbar removePadding" >
                    {
                      <AddStation setOpen={setOpenStationModal} setCreateUpdateStationSuccess={setCreateUpdateStationSuccess} editStationId={station?.station_id}/>
                    }
                  </Box>
                </div>
              </Modal>
              }
              {
                state.user && checkAdminRole(state.user) &&
                <Grid row gap="md">
                  <Grid desktop={{ col: 10 }}/>
                  <Grid desktop={{ col: 2 }}>
                    <Button variant="contained" onClick={()=>{setOpenStationModal(true)}}>
                      Edit Station Metadata
                    </Button>

                  </Grid>
                </Grid>
              }
        <Item>
          <div style={{ padding: '1rem' }}>
            <div style={{ textAlign: 'left' }}>
              <span className="font-sans-md text-bold" >
                Location Data
              </span>
            </div>
            <Divider variant="middle" />
            <Grid row gap="md">
              <Grid
                desktop={{ col: 1 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>NETWORK</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>STATION ID</span>
              </Grid>
              <Grid
                desktop={{ col: 1 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>STATE</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>AGENCY OWNER</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>LATITUDE</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>LONGITUDE</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>ELEVATION</span>
              </Grid>
            </Grid>
            <Grid row gap="md">
              <Grid
                desktop={{ col: 1 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{stationMeta?.network_name}</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{stationMeta?.station_id}</span>
              </Grid>
              <Grid
                desktop={{ col: 1 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{stationMeta?.state}</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{stationMeta?.agency}</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{stationMeta?.latitude}</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{stationMeta?.longitude}</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{stationMeta?.elevation}</span>
              </Grid>
            </Grid>
          </div>
        </Item>
        <Item>
          <div style={{ padding: '1rem' }}>
            <div style={{ textAlign: 'left' }}>
              <span className="font-sans-md text-bold" >
                Site Characteristics
              </span>
            </div>
            <Divider variant="middle" />
            <Grid row gap="md">
              <Grid
                desktop={{ col: 3 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>Grass Type</span>
              </Grid>
              <Grid
                desktop={{ col: 3 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>Aspect/Slope</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>Avg. Annual Precip</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>Min VPD</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>Max VPD</span>
              </Grid>          
            </Grid>
            <Grid row gap="md">
              <Grid
                desktop={{ col: 3 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{!stationMeta || station.fuel_models?.length < 1 ? null : (stationMeta.fuel_models[0]?.grasstype?.includes('P') ? "PERENNIAL" : stationMeta.fuel_models[0]?.grasstype?.includes('A') ? "ANNUAL" : "")}</span>
              </Grid>
              <Grid
                desktop={{ col: 3 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{stationMeta?.aspect_direction}/ {!stationMeta || station.fuel_models?.length < 1 ? null : slopeConversion(stationMeta?.fuel_models[0]?.slopeclass)}</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{stationMeta?.avg_annual_precip}</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{stationMeta?.vpd_min}</span>
              </Grid>
              <Grid
                desktop={{ col: 2 }}
                className="display-flex flex-row flex-align-center flex-justify">
                <span className="font-sans-sm" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>{stationMeta?.vpd_max}</span>
              </Grid>
            </Grid>
          </div>
        </Item>

        {(
          <Item>
          <div style={{ padding: '1rem' }}>
            <div style={{ textAlign: 'left' }}>
              <span className="font-sans-md text-bold" >
                Visibility Settings
              </span>
            </div>
            <Divider variant="middle" />

            <Grid row gap="md">
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>NFDRS Daily Visibility</span>
              </Grid>
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>Weather Daily Visibility</span>
              </Grid>
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>Station Visibility</span>
              </Grid>
            </Grid>

            <Grid row gap="md">
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify">
                  {stationMeta?.nfdrs_daily_visible? 'Visible' : 'Not Visible'}
              </Grid>
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify">
                  {stationMeta?.weather_daily_visible? 'Visible' : 'Not Visible'}
              </Grid>
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify">
                  {stationMeta?.station_metadata_visible? 'Visible' : 'Not Visible'}
              </Grid>
            </Grid>



            <Grid row gap="md">
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>NFDRS Hourly Visibility</span>
              </Grid>
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>Weather Hourly Visibility</span>
              </Grid>
            </Grid>

            <Grid row gap="md">
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify">
                  {stationMeta?.nfdrs_hourly_visible? 'Visible' : 'Not Visible'}
              </Grid>
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify">
                  {stationMeta?.weather_hourly_visible? 'Visible' : 'Not Visible'}
              </Grid>
            </Grid>


            <Grid row gap="md">
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>NFDRS Daily Download Visibility</span>
              </Grid>
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>Weather Daily Download Visibility</span>
              </Grid>
            </Grid>

            <Grid row gap="md">
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify">
                  {stationMeta?.nfdrs_daily_download? 'Visible' : 'Not Visible'}
              </Grid>
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify">
                  {stationMeta?.weather_daily_download? 'Visible' : 'Not Visible'}
              </Grid>
            </Grid>

            <Grid row gap="md">
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>NFDRS Hourly Download Visibility</span>
              </Grid>
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify padding-top-1">
                <span className="font-sans-sm text-bold" style={{ fontSize: '.85rem', textTransform: 'uppercase' }}>Weather Hourly Download Visibility</span>
              </Grid>
            </Grid>

            <Grid row gap="md">
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify">
                  {stationMeta?.nfdrs_hourly_download? 'Visible' : 'Not Visible'}
              </Grid>
              <Grid
                desktop={{ col: 4 }}
                className="display-flex flex-row flex-align-center flex-justify">
                  {stationMeta?.weather_hourly_download? 'Visible' : 'Not Visible'}
              </Grid>
            </Grid>
          </div>
        </Item>
        )}

      </Stack>
    </Box>
  );
}
